import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 3fr 2fr 1fr',
    height: 70,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    '& p': { color: theme.palette.text.secondary },
    gap: 12,
    borderRadius: 20,
    padding: '6px 12px 6px 12px',
    transition: 'background-color 0.3s ease-in-out',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 2fr 3fr 2fr 1fr'
    }
  },
  canRetry: { color: `${theme.palette.secondary.main}!important` },
  cantRetry: { color: `${theme.palette.primary.main}!important` }
}))
export default useStyles
